/**
 * BulletListUI — mirrors aidea.templateengine/src/slides/components/BulletList
 * Renders a styled unordered list with accent bullet marks.
 */
import React from "react";

/* eslint-disable react/prop-types */

export function BulletListUI({ items }) {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <ul
      className="atomic-bullet-list"
      style={{
        listStyle: "none",
        margin: 0,
        padding: 0,
        display: "grid",
        gap: "var(--space-2)",
      }}
    >
      {items.map((item, i) => (
        <li
          key={i}
          style={{
            display: "flex",
            gap: "var(--space-3)",
            alignItems: "flex-start",
            fontFamily: "var(--font-body)",
            fontSize: "var(--text-base)",
            color: "var(--color-text-secondary)",
            lineHeight: 1.5,
          }}
        >
          {/* Bullet mark */}
          <span
            aria-hidden="true"
            style={{
              flexShrink: 0,
              width: "6px",
              height: "6px",
              borderRadius: "50%",
              background: "var(--color-text-accent)",
              marginTop: "0.55em",
            }}
          />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}

export default BulletListUI;
